<script setup lang="ts">
import type { CustomerStageComment } from '@entities/customer'

import { AppText } from '@shared/ui/typography'

import { useCustomerStageComment } from '../model/customer-stage-comment.hook'

defineOptions({
  name: 'CustomerStageComment',
})

const props = defineProps<{
  comment: CustomerStageComment
}>()

const {
  refAgentName,
  refAgentUrl,
  isContacted,
  refChannels,
  refReach,
  isReached,
  refDisciplineLabel,
  refDate,
} = useCustomerStageComment({
  comment: computed(() => props.comment),
})
</script>

<template>
  <div class="customer-stage-comment">
    <div class="customer-stage-comment__head">
      <a
        v-if="refAgentUrl"
        class="customer-stage-comment__agent customer-stage-comment__agent--link"
        :href="refAgentUrl"
        target="_blank"
      >
        {{ refAgentName }}
      </a>
      <span
        v-else
        class="customer-stage-comment__agent"
      >
        {{ refAgentName }}
      </span>
      <span
        v-if="isContacted"
        class="customer-stage-comment__via"
      >
        via
        <span
          v-for="channel in refChannels"
          :key="channel"
          class="customer-stage-comment__channel"
        >
          {{ channel }}
        </span>
        <span
          v-if="refReach"
          :class="['customer-stage-comment__reach', { 'customer-stage-comment__reach--reached': isReached }]"
        >
          {{ refReach }}
        </span>
      </span>
    </div>
    <AppText
      name="body1"
      class="customer-stage-comment__text"
    >
      {{ comment.comment }}
    </AppText>
    <div class="customer-stage-comment__labels">
      <AppText
        v-if="refDisciplineLabel"
        name="body2"
        color="slate-700"
      >
        {{ refDisciplineLabel }}
      </AppText>
      <AppText
        name="body2"
        color="slate-500"
      >
        {{ refDate }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./CustomerStageComment.scss" />
